import {Observable} from 'rxjs';
import {List} from 'immutable';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable} from 'web-app/react/dialog';
import * as BillPayerHelpers from 'web-app/react/entities/bill-payers/helpers';
import * as BillPayerObservables from 'web-app/react/entities/bill-payers/epics';

import * as Actions from './actions';

const removeFromBillPayerSplit = action$ =>
    action$.ofType(Actions.removeBillPayerFromSplit.type).mergeMap(({payload}) => {
        return showDeleteDialogObservable({
            title: '',
            description: i18next.t('billPayer.removeFromSplitConfirmation', {name: payload.billPayerName}),
            okText: i18next.t('remove'),
        }).mergeMap(selection => {
            if (selection === 'OK') {
                const newConfiguration = BillPayerHelpers.removeBillPayerFromSplitConfiguration(
                    payload.oldSplitConfiguration,
                    payload.billPayerId,
                );

                return Observable.of(Actions.removeBillPayerFromSplitSuccess.action(newConfiguration));
            } else {
                return Observable.of(Actions.removeBillPayerFromSplitAborted.action());
            }
        });
    });

const saveSplit = action$ =>
    action$.ofType(Actions.saveSplit.type).mergeMap(({payload}) =>
        BillPayerObservables.updateSplitObservable(payload.institutionId, payload.childId, payload.splitConfiguration)
            .flatMap(splitSuccessAction => List([splitSuccessAction, Actions.saveSplitSuccess.action()]))
            .catch(e => Observable.of(Actions.saveSplitFailed.action(e))),
    );

export default combineEpics(removeFromBillPayerSplit, saveSplit);
